import type { ButtonHTMLAttributes } from "react";

export type ButtonSize = "small" | "medium" | "large";

export type LinkTone = "primary" | "secondary" | "muted" | "danger";

export interface ButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "type"
> {
  type: ButtonTypes;
  size?: ButtonSize;
  children: any;
  disabled?: boolean;
  isLoading?: boolean;
  isFullWidth?: boolean;
  buttonType?: "button" | "submit" | "reset";
  /** Link-only: label color at rest and on hover (defaults to primary). */
  tone?: LinkTone;
  /** Link-only: renders the label underlined at rest. */
  underline?: boolean;
  "data-testid"?: string;
}

export enum ButtonTypes {
  primary = "primary",
  secondary = "secondary",
  cancel = "cancel",
  revert = "revert",
  warning = "warning",
  danger = "danger",
  dangerOutline = "dangerOutline",
  clear = "clear",
  link = "link",
}

export interface StyleProps {
  size?: ButtonSize;
  form?: string;
  $isFullWidth?: boolean;
}
